module.exports = __webpack_public_path__ + "static/img/7.4b983fa.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/zh/7.png
// module id = liBB
// module chunks = 0